/**
 * JMB Brick Co. — Shopify Theme JS
 */

(function() {
  'use strict';

  // ─── Theme toggle (dark / light) ───
  function toggleTheme() {
    var html = document.documentElement;
    var isLight = html.classList.toggle('theme-light');
    localStorage.setItem('theme', isLight ? 'light' : 'dark');
  }
  var themeToggle = document.getElementById('themeToggle');
  if (themeToggle) themeToggle.addEventListener('click', toggleTheme);
  var themeToggleFooter = document.getElementById('themeToggleFooter');
  if (themeToggleFooter) themeToggleFooter.addEventListener('click', toggleTheme);

  // ─── Cart drawer ───
  var cartDrawer = document.getElementById('cartDrawer');
  var cartDrawerTrigger = document.getElementById('cartDrawerTrigger');
  var cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  var cartDrawerClose = document.getElementById('cartDrawerClose');
  /* Shared early — used by cart + mobile overlays (cart_open=1 runs before navbar block). */
  var mobileMq = window.matchMedia('(max-width: 900px)');
  var navLinksContainer = document.querySelector('.nav-links');
  var mobileSearchPanel = document.getElementById('mobileSearchPanel');

  function syncBodyScrollLock() {
    var lock = false;
    if (cartDrawer && cartDrawer.classList.contains('open')) lock = true;
    if (mobileMq.matches && navLinksContainer && navLinksContainer.classList.contains('open')) lock = true;
    if (mobileSearchPanel && mobileSearchPanel.classList.contains('open')) lock = true;
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    if (mobileMq.matches) closeMobileNav();
    if (mobileSearchPanel && mobileSearchPanel.classList.contains('open')) {
      mobileSearchPanel.classList.remove('open');
      mobileSearchPanel.setAttribute('aria-hidden', 'true');
      if (mobileSearchToggle) mobileSearchToggle.setAttribute('aria-expanded', 'false');
    }
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    syncBodyScrollLock();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    syncBodyScrollLock();
  }

  if (cartDrawer && cartDrawerTrigger) {
    if (window.location.search.indexOf('cart_open=1') >= 0) {
      openCartDrawer();
      history.replaceState(null, '', window.location.pathname + window.location.search.replace(/[?&]cart_open=1/, '').replace(/^\?$/, ''));
    }
    cartDrawerTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
    if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);
    if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('open')) closeCartDrawer();
    });
  }

  // ─── Product add: show choices instead of auto-add ───
  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('.product-add-trigger');
    var choice = e.target.closest('.product-add-choice');
    var popover = e.target.closest('.product-add-popover');
    var wrap = e.target.closest('.product-add-wrap');

    if (trigger) {
      e.preventDefault();
      var w = trigger.closest('.product-add-wrap');
      if (!w) return;
      document.querySelectorAll('.product-add-popover.open').forEach(function(p) {
        if (p !== w.querySelector('.product-add-popover')) p.classList.remove('open');
      });
      var p = w.querySelector('.product-add-popover');
      if (p) p.classList.toggle('open');
      return;
    }

    if (choice) {
      e.preventDefault();
      var choiceWrap = choice.closest('.product-add-wrap');
      if (!choiceWrap) return;
      var form = choiceWrap.querySelector('.product-add-form');
      if (!form) return;
      var checkout = choice.classList.contains('product-add-checkout');
      var fd = new FormData(form);
      var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      if (cartAddUrl.indexOf('.js') < 0) cartAddUrl = cartAddUrl.replace(/\/cart\/add\/?$/, '/cart/add.js') || '/cart/add.js';
      document.querySelectorAll('.product-add-popover.open').forEach(function(p) { p.classList.remove('open'); });
      fetch(cartAddUrl, { method: 'POST', body: fd })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.message && data.status === 422) {
            alert(data.description || data.message);
            return;
          }
          if (checkout) {
            window.location.href = '/checkout';
          } else {
            updateCartCount();
            refreshCartDrawer(function() { openCartDrawer(); });
          }
        })
        .catch(function() {
          fd.append('return_to', checkout ? '/checkout' : window.location.href);
          form.action = (window.routes && window.routes.cart_add_url) || '/cart/add';
          form.submit();
        });
      return;
    }

    if (!wrap && !popover) {
      document.querySelectorAll('.product-add-popover.open').forEach(function(p) { p.classList.remove('open'); });
    }
  });

  // ─── Cart helpers ───
  function updateCartCount() {
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
      document.querySelectorAll('.nav-cart-count').forEach(function(el) {
        el.textContent = cart.item_count;
      });
    }).catch(function() {});
  }
  function refreshCartDrawer(cb) {
    fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer-body');
        var current = document.querySelector('.cart-drawer-body');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        if (cb) cb();
      })
      .catch(function() {
        var url = window.location.pathname + window.location.search;
        url += (url.indexOf('?') >= 0 ? '&' : '?') + 'cart_open=1';
        window.location.href = url;
      });
  }

  // ─── Sell steps step-by-step reveal ───
  var sellSteps = document.querySelector('.sell-steps-reveal');
  if (sellSteps) {
    var stepsObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        }
      });
    }, { threshold: 0.2, rootMargin: '0px' });
    stepsObserver.observe(sellSteps);
  }

  // ─── Custom Cursor (desktop only) ───
  const cursor = document.getElementById('cursor');
  const ring = document.getElementById('cursorRing');
  const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  let mx = 0, my = 0, rx = 0, ry = 0;

  if (hasFinePointer && cursor && ring) {
    document.addEventListener('mousemove', function(e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.transform = 'translate(' + (mx - 5) + 'px, ' + (my - 5) + 'px)';
    });

    function animateRing() {
      rx += (mx - rx - 18) * 0.12;
      ry += (my - ry - 18) * 0.12;
      ring.style.transform = 'translate(' + rx + 'px, ' + ry + 'px)';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    var cursorHover = false;
    document.querySelectorAll('a, button').forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        cursorHover = true;
        ring.style.width = '50px'; ring.style.height = '50px';
        ring.style.borderColor = 'rgba(212,129,26,0.6)';
      });
      el.addEventListener('mouseleave', function() {
        cursorHover = false;
        ring.style.width = '36px'; ring.style.height = '36px';
        ring.style.borderColor = 'rgba(0,229,255,0.5)';
      });
    });
  }

  // ─── Navbar Scroll & Mobile Toggle ───
  var navbar = document.getElementById('navbar');
  var navToggle = document.getElementById('navToggle');
  var lastScrollY = 0;
  var scrollTicking = false;

  function closeMobileNav() {
    if (navLinksContainer) navLinksContainer.classList.remove('open');
    if (navToggle) {
      navToggle.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
    }
    syncBodyScrollLock();
  }

  function updateNavScroll() {
    if (!navbar) { scrollTicking = false; return; }
    if (lastScrollY > 50) navbar.classList.add('scrolled');
    else navbar.classList.remove('scrolled');
    scrollTicking = false;
  }

  window.addEventListener('scroll', function() {
    lastScrollY = window.scrollY;
    if (!scrollTicking) {
      requestAnimationFrame(updateNavScroll);
      scrollTicking = true;
    }
  }, { passive: true });

  if (navToggle && navLinksContainer) {
    navToggle.addEventListener('click', function() {
      var isOpen = navLinksContainer.classList.toggle('open');
      navToggle.classList.toggle('open', isOpen);
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      syncBodyScrollLock();
    });
    document.addEventListener('click', function(e) {
      if (mobileMq.matches && navLinksContainer.classList.contains('open')
          && !e.target.closest('.nav-links') && !e.target.closest('.nav-toggle')) {
        closeMobileNav();
      }
    });
  }

  // ─── Mobile search panel (slide-down overlay) ───
  var mobileSearchToggle = document.getElementById('mobileSearchToggle');
  var mobileSearchClose = document.getElementById('mobileSearchClose');
  var mobileSearchInput = document.getElementById('mobileSearchInput');

  function closeMobileSearch() {
    if (!mobileSearchPanel) return;
    mobileSearchPanel.classList.remove('open');
    mobileSearchPanel.setAttribute('aria-hidden', 'true');
    if (mobileSearchToggle) mobileSearchToggle.setAttribute('aria-expanded', 'false');
    syncBodyScrollLock();
  }

  function openMobileSearch() {
    if (!mobileSearchPanel) return;
    if (navLinksContainer) navLinksContainer.classList.remove('open');
    if (navToggle) {
      navToggle.classList.remove('open');
      navToggle.setAttribute('aria-expanded', 'false');
    }
    mobileSearchPanel.classList.add('open');
    mobileSearchPanel.setAttribute('aria-hidden', 'false');
    if (mobileSearchToggle) mobileSearchToggle.setAttribute('aria-expanded', 'true');
    if (mobileSearchInput) {
      // Delay focus so the slide-down animation has time to start
      setTimeout(function() { mobileSearchInput.focus(); }, 80);
    }
    syncBodyScrollLock();
  }

  if (mobileSearchToggle && mobileSearchPanel) {
    mobileSearchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (mobileSearchPanel.classList.contains('open')) closeMobileSearch();
      else openMobileSearch();
    });
  }
  if (mobileSearchClose) {
    mobileSearchClose.addEventListener('click', function(e) {
      e.preventDefault();
      closeMobileSearch();
    });
  }
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mobileSearchPanel && mobileSearchPanel.classList.contains('open')) {
      closeMobileSearch();
    }
  });
  document.addEventListener('click', function(e) {
    if (!mobileSearchPanel || !mobileSearchPanel.classList.contains('open')) return;
    if (e.target.closest('#mobileSearchPanel') || e.target.closest('#mobileSearchToggle')) return;
    closeMobileSearch();
  });

  // ─── Particles (desktop only — major perf win on mobile) ───
  var particlesContainer = document.getElementById('particles');
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (particlesContainer && !mobileMq.matches && !prefersReducedMotion) {
    for (var i = 0; i < 16; i++) {
      var p = document.createElement('div');
      p.className = 'particle';
      p.style.left = Math.random() * 100 + '%';
      p.style.bottom = '0';
      p.style.width = (4 + Math.random() * 6) + 'px';
      p.style.height = p.style.width;
      p.style.animationDuration = (8 + Math.random() * 12) + 's';
      p.style.animationDelay = (Math.random() * 10) + 's';
      var r = Math.random();
      if (r > 0.66) {
        p.style.background = 'var(--cyan)';
        p.style.boxShadow = '0 0 6px var(--cyan-glow)';
      } else if (r > 0.33) {
        p.className = 'particle particle--accent';
      } else {
        p.style.background = 'var(--orange)';
        p.style.boxShadow = '0 0 6px var(--orange-glow)';
      }
      particlesContainer.appendChild(p);
    }
  }

  // ─── Scroll Reveal ───
  var revealEls = document.querySelectorAll('.reveal');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  revealEls.forEach(function(el) { observer.observe(el); });

  // ─── Active nav on scroll (throttled, only for in-page anchor links) ───
  var navLinks = document.querySelectorAll('.nav-link[href^="#"]');
  if (navLinks.length > 0) {
    var anchorSections = [];
    navLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      if (!href || href.length < 2) return;
      var el = document.getElementById(href.slice(1));
      if (el) anchorSections.push({ el: el, link: link });
    });

    if (anchorSections.length > 0) {
      var lastActiveNavScrollTime = 0;
      function updateActiveNav() {
        var y = window.scrollY + 200;
        var currentLink = null;
        for (var i = anchorSections.length - 1; i >= 0; i--) {
          if (y >= anchorSections[i].el.offsetTop) {
            currentLink = anchorSections[i].link;
            break;
          }
        }
        navLinks.forEach(function(link) { link.classList.remove('active'); });
        if (currentLink) currentLink.classList.add('active');
      }
      // Throttle to ~10fps — this work doesn't need 60fps and frees up scroll thread on mobile.
      window.addEventListener('scroll', function() {
        var now = Date.now();
        if (now - lastActiveNavScrollTime > 100) {
          lastActiveNavScrollTime = now;
          requestAnimationFrame(updateActiveNav);
        }
      }, { passive: true });
    }
  }

  // ─── Smooth anchor scroll ───
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target;
      try { target = document.querySelector(href); } catch(x) { return; }
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
        // Close mobile nav
        if (navLinksContainer && navToggle && navLinksContainer.classList.contains('open') && mobileMq.matches) {
          navLinksContainer.classList.remove('open');
          navToggle.classList.remove('open');
          navToggle.setAttribute('aria-expanded', 'false');
          syncBodyScrollLock();
        }
      }
    });
  });

  // ─── Mobile carousels: auto-swipe + click/touch to swipe ───
  var carouselWrap = 'data-mobile-carousel';
  var carouselInterval = 4500;
  var carouselIntervals = [];

  function getScrollStep(container) {
    var first = container.querySelector('[class*="card"], .product-card, .collection-card, .why-card, .testimonial-card');
    return first ? first.offsetWidth + 20 : 300;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function smoothScrollTo(container, targetLeft, durationMs) {
    if (!container || durationMs <= 0) {
      if (container) container.scrollLeft = targetLeft;
      return;
    }
    var start = container.scrollLeft;
    var startTime = null;
    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var progress = Math.min(elapsed / durationMs, 1);
      var eased = easeOutCubic(progress);
      container.scrollLeft = start + (targetLeft - start) * eased;
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function advanceCarousel(container) {
    if (!container) return;
    var step = getScrollStep(container);
    var max = container.scrollWidth - container.clientWidth;
    if (max <= 0) return;
    var next = Math.min(container.scrollLeft + step, max);
    if (next >= max - 2) next = 0;
    smoothScrollTo(container, next, 520);
  }

  function retreatCarousel(container) {
    if (!container) return;
    var step = getScrollStep(container);
    var next = Math.max(0, container.scrollLeft - step);
    smoothScrollTo(container, next, 520);
  }

  function setupCarousel(wrap) {
    if (!wrap) return;
    if (!wrap.getAttribute('data-carousel-id')) {
      wrap.setAttribute('data-carousel-id', 'c' + Math.random().toString(36).slice(2, 9));
    }
    // Auto-advance disabled on mobile — it fights user touch scrolling and causes jank.
    // Mobile users can swipe naturally via native touch scroll on the horizontal container.
    wrap.addEventListener('click', function(e) {
      if (mobileMq.matches) return;
      if (e.target.closest('a, button')) return;
      var rect = wrap.getBoundingClientRect();
      var x = e.clientX - rect.left;
      if (x > rect.width * 0.6) advanceCarousel(wrap);
      else if (x < rect.width * 0.4) retreatCarousel(wrap);
    });
  }

  document.querySelectorAll('[' + carouselWrap + ']').forEach(setupCarousel);

  // ─── Shop grid toggle ───
  document.querySelectorAll('.grid-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var cols = this.getAttribute('data-cols');
      var grid = document.getElementById('shopGrid');
      if (!grid) return;
      document.querySelectorAll('.grid-toggle').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');
      grid.classList.remove('cols-2');
      if (cols === '2') grid.classList.add('cols-2');
    });
  });

  // ─── Curved 3D Slider ───
  var curvedSlider = document.getElementById('curvedSlider');
  if (curvedSlider) {
    var slides = curvedSlider.querySelectorAll('.curved-slide');
    var dotsContainer = document.getElementById('curvedDots');
    var prevBtn = document.getElementById('curvedPrev');
    var nextBtn = document.getElementById('curvedNext');
    var totalSlides = slides.length;
    var currentSlide = 0;
    var autoplayTimer = null;
    var autoplayDelay = 4000;

    if (dotsContainer) {
      for (var di = 0; di < totalSlides; di++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'curved-dot' + (di === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (di + 1));
        dot.setAttribute('data-slide', di);
        dotsContainer.appendChild(dot);
      }
      dotsContainer.addEventListener('click', function(e) {
        var dotBtn = e.target.closest('.curved-dot');
        if (!dotBtn) return;
        goToSlide(parseInt(dotBtn.getAttribute('data-slide'), 10));
        resetAutoplay();
      });
    }

    function positionSlides() {
      var angleStep = 360 / totalSlides;
      var isMobile = window.innerWidth <= 480;
      var isTablet = window.innerWidth <= 900;
      var radius = isMobile ? 320 : (isTablet ? 380 : 480);

      slides.forEach(function(slide, i) {
        var offset = ((i - currentSlide) % totalSlides + totalSlides) % totalSlides;
        if (offset > totalSlides / 2) offset -= totalSlides;
        var angle = offset * angleStep;
        var rad = angle * Math.PI / 180;
        var x = Math.sin(rad) * radius;
        var z = Math.cos(rad) * radius - radius;
        var rotY = -angle * 0.6;
        var scale = 1 - Math.abs(offset) * 0.08;
        if (scale < 0.6) scale = 0.6;
        var opa = 1 - Math.abs(offset) * 0.2;
        if (opa < 0.3) opa = 0.3;
        var blur = 0;
        if (!mobileMq.matches) {
          blur = Math.abs(offset) > 1 ? Math.min((Math.abs(offset) - 1) * 1.5, 4) : 0;
        }

        slide.style.transform = 'translateX(' + x + 'px) translateZ(' + z + 'px) rotateY(' + rotY + 'deg) scale(' + scale + ')';
        slide.style.opacity = opa;
        slide.style.filter = blur > 0 ? 'blur(' + blur + 'px)' : 'none';
        slide.style.zIndex = 100 - Math.abs(offset);
        slide.style.pointerEvents = offset === 0 ? 'auto' : 'none';

        if (offset === 0) slide.classList.add('active');
        else slide.classList.remove('active');
      });

      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.curved-dot');
        dots.forEach(function(d, i) {
          d.classList.toggle('active', i === currentSlide);
        });
      }
    }

    function goToSlide(idx) {
      currentSlide = ((idx % totalSlides) + totalSlides) % totalSlides;
      positionSlides();
    }

    function nextSlide() { goToSlide(currentSlide + 1); }
    function prevSlide() { goToSlide(currentSlide - 1); }

    function resetAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (mobileMq.matches || prefersReducedMotion) return;
      autoplayTimer = setInterval(nextSlide, autoplayDelay);
    }

    if (nextBtn) nextBtn.addEventListener('click', function() { nextSlide(); resetAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { prevSlide(); resetAutoplay(); });

    var touchStartX = 0;
    var touchDelta = 0;
    curvedSlider.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchDelta = 0;
    }, { passive: true });
    curvedSlider.addEventListener('touchmove', function(e) {
      touchDelta = e.touches[0].clientX - touchStartX;
    }, { passive: true });
    curvedSlider.addEventListener('touchend', function() {
      if (Math.abs(touchDelta) > 40) {
        if (touchDelta < 0) nextSlide();
        else prevSlide();
        resetAutoplay();
      }
    });

    positionSlides();
    resetAutoplay();

    window.addEventListener('resize', function() {
      positionSlides();
      if (mobileMq.matches || prefersReducedMotion) {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      } else {
        resetAutoplay();
      }
    });

    var sliderObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) resetAutoplay();
        else {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
          }
        }
      });
    }, { threshold: 0.2 });
    sliderObserver.observe(curvedSlider);
  }

  // ─── Auto-scroll to success/error banners after form submit ───
  var successBanner = document.getElementById('sellSuccess');
  var errorBanner = document.querySelector('.sell-error-banner');
  var scrollTarget = successBanner || errorBanner;
  if (scrollTarget) {
    setTimeout(function() {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 300);
  }

})();

// ─── FAQ Toggle (global scope for onclick handlers) ───
function toggleFaq(el) {
  var item = el.parentElement;
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(i) { i.classList.remove('open'); });
  if (!isOpen) item.classList.add('open');
}
